import { useState } from 'react';

const POLL_INTERVAL_MS = 2000;
const POLL_TIMEOUT_MS = 30000;

export const usePoll = <T>(
  refetch: () => Promise<{ data?: T }>,
  isSatisfied: (data: T) => boolean
) => {
  const [isPolling, setIsPolling] = useState(false);

  const poll = async (): Promise<T | undefined> => {
    setIsPolling(true);

    const startedAt = Date.now();
    let lastData: T | undefined;

    try {
      while (Date.now() - startedAt < POLL_TIMEOUT_MS) {
        const result = await refetch();
        lastData = result.data;

        if (result.data && isSatisfied(result.data)) {
          return result.data;
        }

        await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
      }

      return lastData;
    } finally {
      setIsPolling(false);
    }
  };

  return { isPolling, poll };
};
